export default __webpack_public_path__ + "static/media/Harness of Clarity.8cf71461.jpg";